<template>
  <svg
    width="536"
    height="335"
    viewBox="0 0 536 335"
    xmlns="http://www.w3.org/2000/svg"
    fill="var(--color-background-gray-subtlest)"
  >
    <circle
      cx="375.458"
      cy="111.313"
      r="1.46651"
      fill="#FF6300"
    />
    <circle
      cx="399.672"
      cy="102.513"
      r="1.46651"
      fill="#FF6300"
    />
    <circle
      cx="361.841"
      cy="116.131"
      r="1.25701"
      fill="#FF6300"
    />
    <circle
      cx="354.456"
      cy="123.341"
      r="1.25701"
      fill="#FF6300"
    />
    <circle
      cx="325.881"
      cy="121.054"
      r="1.25701"
      fill="#FF6300"
    />
    <circle
      cx="347.506"
      cy="120.741"
      r="1.25701"
      fill="#FF6300"
    />
    <circle
      cx="334.606"
      cy="125.768"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="344.573"
      cy="121.997"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="341.464"
      cy="127.493"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="339.178"
      cy="119.492"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="349.465"
      cy="117.206"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="356.323"
      cy="119.492"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="338.035"
      cy="127.493"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="334.606"
      cy="130.922"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="366.361"
      cy="114.455"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="384.797"
      cy="107.751"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="389.825"
      cy="106.075"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="338.288"
      cy="124.092"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="340.802"
      cy="123.255"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="352.534"
      cy="119.065"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="355.048"
      cy="118.226"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="371.808"
      cy="112.36"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="368.477"
      cy="112.215"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="358.19"
      cy="115.644"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="350.189"
      cy="122.503"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="344.474"
      cy="125.931"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="338.759"
      cy="129.36"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="329.615"
      cy="123.646"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="334.187"
      cy="122.503"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="329.615"
      cy="127.074"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="357.047"
      cy="117.93"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="379.35"
      cy="109.847"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="396.11"
      cy="103.98"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="405.329"
      cy="100.628"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="407.842"
      cy="99.7906"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="419.575"
      cy="95.6002"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="429.631"
      cy="92.2481"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="450.581"
      cy="84.7061"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="441.363"
      cy="88.0582"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="443.877"
      cy="87.2198"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="423.346"
      cy="94.3429"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="413.289"
      cy="97.6949"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="167.709"
      cy="51.6166"
      r="1.46651"
      transform="rotate(65.9861 167.709 51.6166)"
      fill="#FF6300"
    />
    <circle
      cx="194.615"
      cy="80.0926"
      r="1.46651"
      transform="rotate(65.9861 194.615 80.0926)"
      fill="#FF6300"
    />
    <circle
      cx="202.216"
      cy="88.4029"
      r="1.25701"
      transform="rotate(65.9861 202.216 88.4029)"
      fill="#FF6300"
    />
    <circle
      cx="156.871"
      cy="40.1612"
      r="0.838007"
      transform="rotate(65.9861 156.871 40.1612)"
      fill="#FF6300"
    />
    <circle
      cx="160.448"
      cy="44.0714"
      r="0.838007"
      transform="rotate(65.9861 160.448 44.0714)"
      fill="#FF6300"
    />
    <circle
      cx="147.375"
      cy="30.1714"
      r="0.419004"
      transform="rotate(65.9861 147.375 30.1714)"
      fill="#FF6300"
    />
    <circle
      cx="152.74"
      cy="36.0381"
      r="0.419004"
      transform="rotate(65.9861 152.74 36.0381)"
      fill="#FF6300"
    />
    <circle
      cx="164.92"
      cy="48.961"
      r="0.419004"
      transform="rotate(65.9861 164.92 48.961)"
      fill="#FF6300"
    />
    <circle
      cx="171.733"
      cy="56.0166"
      r="0.419004"
      transform="rotate(65.9861 171.733 56.0166)"
      fill="#FF6300"
    />
    <circle
      cx="173.521"
      cy="57.9722"
      r="0.419004"
      transform="rotate(65.9861 173.521 57.9722)"
      fill="#FF6300"
    />
    <circle
      cx="182.123"
      cy="66.9834"
      r="0.419004"
      transform="rotate(65.9861 182.123 66.9834)"
      fill="#FF6300"
    />
    <circle
      cx="189.277"
      cy="74.8047"
      r="0.419004"
      transform="rotate(65.9861 189.277 74.8047)"
      fill="#FF6300"
    />
    <circle
      cx="204.692"
      cy="90.8726"
      r="0.419004"
      transform="rotate(65.9861 204.692 90.8726)"
      fill="#FF6300"
    />
    <circle
      cx="197.879"
      cy="83.8159"
      r="0.419004"
      transform="rotate(65.9861 197.879 83.8159)"
      fill="#FF6300"
    />
    <circle
      cx="199.668"
      cy="85.7715"
      r="0.419004"
      transform="rotate(65.9861 199.668 85.7715)"
      fill="#FF6300"
    />
    <circle
      cx="211.847"
      cy="98.6944"
      r="0.419004"
      transform="rotate(65.9861 211.847 98.6944)"
      fill="#FF6300"
    />
    <circle
      cx="184.806"
      cy="69.9166"
      r="0.838007"
      transform="rotate(65.9861 184.806 69.9166)"
      fill="#FF6300"
    />
    <circle
      cx="209.164"
      cy="95.7613"
      r="0.838007"
      transform="rotate(65.9861 209.164 95.7613)"
      fill="#FF6300"
    />
    <circle
      cx="177.652"
      cy="62.0948"
      r="0.838007"
      transform="rotate(65.9861 177.652 62.0948)"
      fill="#FF6300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M167.049 174.381L167.049 118.916L279.942 77.9453L354.763 157.507V214.029L241.606 253.927L167.049 174.381ZM201.54 149.546L239.639 189.777C240.997 191.212 243.07 191.718 244.937 191.071L312.747 167.551L282.384 133.189L277.516 127.953C274.498 124.707 269.833 123.578 265.665 125.084L201.54 149.546ZM276.815 80.5425C278.071 80.089 279.477 80.4249 280.393 81.3973L349.565 154.845C350.395 155.726 350.046 157.169 348.906 157.574L347.096 158.216L277.034 83.7605L172.866 121.471L172.216 120.773C171.397 119.893 171.743 118.463 172.873 118.055L276.815 80.5425Z"
    />
    <path
      d="M167.049 118.916L167.049 174.381L241.606 253.927M167.049 118.916L279.942 77.9453L354.763 157.507M167.049 118.916L241.87 198.198M241.606 253.927L354.763 214.029V157.507M241.606 253.927L241.87 198.198M354.763 157.507L241.87 198.198M172.866 121.471L172.216 120.773C171.397 119.893 171.743 118.463 172.873 118.055L276.815 80.5425C278.071 80.089 279.477 80.4249 280.393 81.3973L349.565 154.845C350.395 155.726 350.046 157.169 348.906 157.574L347.096 158.216M172.866 121.471L240.37 193.96C241.281 194.938 242.685 195.281 243.945 194.834L347.096 158.216M172.866 121.471L277.034 83.7605L347.096 158.216M201.54 149.546L182.142 127.333C180.599 125.566 181.302 122.801 183.501 121.985L265.665 91.5189M201.54 149.546L239.639 189.777C240.997 191.212 243.07 191.718 244.937 191.071L312.747 167.551M201.54 149.546L265.665 125.084M312.747 167.551L335.697 159.242C337.962 158.421 338.648 155.551 336.999 153.795L282.384 95.6552M312.747 167.551L282.384 133.189M265.665 125.084V125.084C269.833 123.578 274.498 124.707 277.516 127.953L282.384 133.189M265.665 125.084V91.5189M265.665 91.5189L266.841 91.083C271.896 89.2084 277.583 90.5446 281.275 94.4746L282.384 95.6552M282.384 95.6552V133.189"
      stroke="#040301"
      stroke-opacity="0.41"
      stroke-width="0.838007"
      stroke-linejoin="round"
      fill="none"
    />
    <ellipse
      cx="201.225"
      cy="187.47"
      rx="3.49071"
      ry="6.39963"
      transform="rotate(-15.3002 201.225 187.47)"
      fill="transparent"
      stroke="#040301"
      stroke-opacity="0.41"
      stroke-width="0.838007"
      stroke-linejoin="round"
    />
    <path
      d="M201.594 187.103C202.235 189.446 201.806 191.604 200.636 191.924C199.466 192.244 197.998 190.605 197.357 188.262C196.716 185.92 197.145 183.761 198.315 183.441C199.485 183.121 200.953 184.761 201.594 187.103Z"
      fill="transparent"
    />
    <path
      d="M201.594 187.103C202.235 189.446 201.806 191.604 200.636 191.924M201.594 187.103C200.953 184.761 199.485 183.121 198.315 183.441M201.594 187.103L204.576 186.633M200.636 191.924C199.466 192.244 197.998 190.605 197.357 188.262C196.716 185.92 197.145 183.761 198.315 183.441M200.636 191.924L202.9 193.756M198.315 183.441L199.967 181.186"
      stroke="#040301"
      stroke-opacity="0.41"
      stroke-width="0.838007"
      stroke-linejoin="round"
    />
    <ellipse
      cx="199.09"
      cy="188.123"
      rx="0.779365"
      ry="1.76614"
      transform="rotate(-15.3002 199.09 188.123)"
      fill="black"
      fill-opacity="0.4"
    />
    <ellipse
      cx="5.17724"
      cy="6.39963"
      rx="5.17724"
      ry="6.39963"
      transform="matrix(-0.964556 -0.263877 -0.263877 0.964556 310.655 200.512)"
      fill="transparent"
      stroke="#040301"
      stroke-opacity="0.41"
      stroke-width="0.838007"
      stroke-linejoin="round"
    />
    <path
      d="M300.911 204.586C300.235 207.058 301.168 209.466 302.996 209.966C303.149 210.008 303.303 210.035 303.458 210.048C305.153 210.193 306.909 208.661 307.529 206.397C308.205 203.926 307.271 201.517 305.444 201.017C305.341 200.989 305.238 200.967 305.134 200.952C303.392 200.7 301.549 202.254 300.911 204.586Z"
      fill="transparent"
    />
    <path
      d="M300.911 204.586C300.235 207.058 301.168 209.466 302.996 209.966C303.149 210.008 303.303 210.035 303.458 210.048M300.911 204.586L298.849 203.883M300.911 204.586C301.549 202.254 303.392 200.7 305.134 200.952M305.134 200.952C305.238 200.967 305.341 200.989 305.444 201.017C307.271 201.517 308.205 203.926 307.529 206.397C306.909 208.661 305.153 210.193 303.458 210.048M305.134 200.952L303.458 198.855M303.458 210.048L302.62 211.425"
      stroke="#040301"
      stroke-opacity="0.41"
      stroke-width="0.838007"
      stroke-linejoin="round"
    />
    <path
      d="M303.069 205.162C302.803 206.1 303.165 207.024 303.876 207.226C304.588 207.427 305.38 206.829 305.646 205.891C305.911 204.952 305.55 204.028 304.838 203.827C304.126 203.625 303.334 204.223 303.069 205.162Z"
      fill="black"
      fill-opacity="0.4"
    />
    <circle
      cx="112.565"
      cy="218.716"
      r="1.46651"
      fill="#FF6300"
    />
    <circle
      cx="136.779"
      cy="209.917"
      r="1.46651"
      fill="#FF6300"
    />
    <circle
      cx="173.74"
      cy="196.927"
      r="1.46651"
      fill="#FF6300"
    />
    <circle
      cx="168.234"
      cy="196.178"
      r="1.46651"
      fill="#FF6300"
    />
    <circle
      cx="184.424"
      cy="193.366"
      r="1.25701"
      fill="#FF6300"
    />
    <circle
      cx="186.312"
      cy="187.968"
      r="1.25701"
      fill="#FF6300"
    />
    <circle
      cx="98.9477"
      cy="223.534"
      r="1.25701"
      fill="#FF6300"
    />
    <circle
      cx="103.469"
      cy="221.858"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="121.905"
      cy="215.154"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="126.933"
      cy="213.478"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="75.3951"
      cy="231.495"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="77.9088"
      cy="230.657"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="89.6414"
      cy="226.467"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="92.1551"
      cy="225.629"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="108.915"
      cy="219.763"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="116.458"
      cy="217.249"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="133.218"
      cy="211.383"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="142.436"
      cy="208.031"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="144.95"
      cy="207.193"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="146.612"
      cy="205.418"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="153.47"
      cy="206.561"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="156.682"
      cy="203.003"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="162.614"
      cy="198.56"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="166.738"
      cy="199.65"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="166.043"
      cy="200.846"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="166.043"
      cy="204.275"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="178.616"
      cy="201.989"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="183.188"
      cy="200.846"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="192.333"
      cy="193.988"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="187.688"
      cy="192.109"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="196.905"
      cy="193.988"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="188.903"
      cy="182.558"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="178.47"
      cy="195.461"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="172.901"
      cy="191.702"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="177.473"
      cy="190.559"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="177.473"
      cy="187.13"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="182.045"
      cy="187.13"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="180.984"
      cy="194.623"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="197.744"
      cy="188.757"
      r="0.419004"
      fill="#FF6300"
    />
    <circle
      cx="160.453"
      cy="201.746"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="160.747"
      cy="205.837"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="193.973"
      cy="190.013"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="150.397"
      cy="205.098"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="152.746"
      cy="201.265"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="157.318"
      cy="198.979"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="173.32"
      cy="201.265"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="168.748"
      cy="200.122"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="180.178"
      cy="192.121"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="184.75"
      cy="184.12"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="187.036"
      cy="197.836"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="195.037"
      cy="197.836"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="192.752"
      cy="185.263"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="181.321"
      cy="198.979"
      r="0.838007"
      fill="#FF6300"
    />
    <circle
      cx="337.327"
      cy="242.251"
      r="1.46651"
      transform="rotate(65.9861 337.327 242.251)"
      fill="#FF6300"
    />
    <circle
      cx="355.218"
      cy="260.789"
      r="1.46651"
      transform="rotate(65.9861 355.218 260.789)"
      fill="#FF6300"
    />
    <circle
      cx="327.384"
      cy="231.774"
      r="1.25701"
      transform="rotate(65.9861 327.384 231.774)"
      fill="#FF6300"
    />
    <circle
      cx="317.34"
      cy="220.556"
      r="1.25701"
      transform="rotate(65.9861 317.34 220.556)"
      fill="#FF6300"
    />
    <circle
      cx="319.425"
      cy="227.756"
      r="1.25701"
      transform="rotate(65.9861 319.425 227.756)"
      fill="#FF6300"
    />
    <circle
      cx="303.423"
      cy="212.897"
      r="1.25701"
      transform="rotate(65.9861 303.423 212.897)"
      fill="#FF6300"
    />
    <circle
      cx="307.497"
      cy="210.818"
      r="0.838007"
      transform="rotate(65.9861 307.497 210.818)"
      fill="#FF6300"
    />
    <circle
      cx="314.998"
      cy="218.388"
      r="0.838007"
      transform="rotate(65.9861 314.998 218.388)"
      fill="#FF6300"
    />
    <circle
      cx="330.754"
      cy="235.221"
      r="0.838007"
      transform="rotate(65.9861 330.754 235.221)"
      fill="#FF6300"
    />
    <circle
      cx="324.588"
      cy="224.917"
      r="0.838007"
      transform="rotate(65.9861 324.588 224.917)"
      fill="#FF6300"
    />
    <circle
      cx="321.159"
      cy="215.773"
      r="0.838007"
      transform="rotate(65.9861 321.159 215.773)"
      fill="#FF6300"
    />
    <circle
      cx="315.443"
      cy="213.487"
      r="0.838007"
      transform="rotate(65.9861 315.443 213.487)"
      fill="#FF6300"
    />
    <circle
      cx="309.729"
      cy="216.916"
      r="0.838007"
      transform="rotate(65.9861 309.729 216.916)"
      fill="#FF6300"
    />
    <circle
      cx="310.871"
      cy="220.345"
      r="0.838007"
      transform="rotate(65.9861 310.871 220.345)"
      fill="#FF6300"
    />
    <circle
      cx="344.381"
      cy="249.334"
      r="0.838007"
      transform="rotate(65.9861 344.381 249.334)"
      fill="#FF6300"
    />
    <circle
      cx="347.958"
      cy="253.244"
      r="0.838007"
      transform="rotate(65.9861 347.958 253.244)"
      fill="#FF6300"
    />
    <circle
      cx="310.527"
      cy="213.5"
      r="0.419004"
      transform="rotate(65.9861 310.527 213.5)"
      fill="#FF6300"
    />
    <circle
      cx="312.315"
      cy="215.455"
      r="0.419004"
      transform="rotate(65.9861 312.315 215.455)"
      fill="#FF6300"
    />
    <circle
      cx="320.917"
      cy="224.467"
      r="0.419004"
      transform="rotate(65.9861 320.917 224.467)"
      fill="#FF6300"
    />
    <circle
      cx="322.706"
      cy="226.422"
      r="0.419004"
      transform="rotate(65.9861 322.706 226.422)"
      fill="#FF6300"
    />
    <circle
      cx="334.885"
      cy="239.344"
      r="0.419004"
      transform="rotate(65.9861 334.885 239.344)"
      fill="#FF6300"
    />
    <circle
      cx="327.463"
      cy="227.793"
      r="0.419004"
      transform="rotate(65.9861 327.463 227.793)"
      fill="#FF6300"
    />
    <circle
      cx="322.891"
      cy="220.935"
      r="0.419004"
      transform="rotate(65.9861 322.891 220.935)"
      fill="#FF6300"
    />
    <circle
      cx="316.033"
      cy="216.363"
      r="0.419004"
      transform="rotate(65.9861 316.033 216.363)"
      fill="#FF6300"
    />
    <circle
      cx="317.176"
      cy="211.791"
      r="0.419004"
      transform="rotate(65.9861 317.176 211.791)"
      fill="#FF6300"
    />
    <circle
      cx="314.89"
      cy="210.648"
      r="0.419004"
      transform="rotate(65.9861 314.89 210.648)"
      fill="#FF6300"
    />
    <circle
      cx="314.89"
      cy="207.219"
      r="0.419004"
      transform="rotate(65.9861 314.89 207.219)"
      fill="#FF6300"
    />
    <circle
      cx="311.461"
      cy="210.648"
      r="0.419004"
      transform="rotate(65.9861 311.461 210.648)"
      fill="#FF6300"
    />
    <circle
      cx="306.889"
      cy="214.077"
      r="0.419004"
      transform="rotate(65.9861 306.889 214.077)"
      fill="#FF6300"
    />
    <circle
      cx="313.747"
      cy="220.935"
      r="0.419004"
      transform="rotate(65.9861 313.747 220.935)"
      fill="#FF6300"
    />
    <circle
      cx="305.746"
      cy="217.506"
      r="0.419004"
      transform="rotate(65.9861 305.746 217.506)"
      fill="#FF6300"
    />
    <circle
      cx="317.176"
      cy="224.364"
      r="0.419004"
      transform="rotate(65.9861 317.176 224.364)"
      fill="#FF6300"
    />
    <circle
      cx="322.891"
      cy="228.936"
      r="0.419004"
      transform="rotate(65.9861 322.891 228.936)"
      fill="#FF6300"
    />
    <circle
      cx="340.251"
      cy="245.21"
      r="0.419004"
      transform="rotate(65.9861 340.251 245.21)"
      fill="#FF6300"
    />
    <circle
      cx="352.43"
      cy="258.132"
      r="0.419004"
      transform="rotate(65.9861 352.43 258.132)"
      fill="#FF6300"
    />
    <circle
      cx="359.243"
      cy="265.189"
      r="0.419004"
      transform="rotate(65.9861 359.243 265.189)"
      fill="#FF6300"
    />
    <circle
      cx="361.031"
      cy="267.143"
      r="0.419004"
      transform="rotate(65.9861 361.031 267.143)"
      fill="#FF6300"
    />
    <circle
      cx="369.633"
      cy="276.156"
      r="0.419004"
      transform="rotate(65.9861 369.633 276.156)"
      fill="#FF6300"
    />
    <circle
      cx="376.788"
      cy="283.977"
      r="0.419004"
      transform="rotate(65.9861 376.788 283.977)"
      fill="#FF6300"
    />
    <circle
      cx="385.39"
      cy="292.988"
      r="0.419004"
      transform="rotate(65.9861 385.39 292.988)"
      fill="#FF6300"
    />
    <circle
      cx="387.178"
      cy="294.944"
      r="0.419004"
      transform="rotate(65.9861 387.178 294.944)"
      fill="#FF6300"
    />
    <circle
      cx="372.316"
      cy="279.089"
      r="0.838007"
      transform="rotate(65.9861 372.316 279.089)"
      fill="#FF6300"
    />
    <circle
      cx="365.162"
      cy="271.266"
      r="0.838007"
      transform="rotate(65.9861 365.162 271.266)"
      fill="#FF6300"
    />
    <circle
      cx="309.653"
      cy="124.458"
      r="1.33829"
      transform="rotate(142.441 309.653 124.458)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="295.017"
      cy="139.088"
      r="1.33829"
      transform="rotate(142.441 295.017 139.088)"
      fill="#FF6300"
    />
    <circle
      cx="286.614"
      cy="130.356"
      r="1.33829"
      transform="rotate(142.441 286.614 130.356)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="272.931"
      cy="142.567"
      r="1.33829"
      transform="rotate(142.441 272.931 142.567)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="279.948"
      cy="147.301"
      r="1.33829"
      transform="rotate(142.441 279.948 147.301)"
      fill="#FF6300"
    />
    <circle
      cx="294.471"
      cy="153.015"
      r="1.33829"
      transform="rotate(142.441 294.471 153.015)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="310.302"
      cy="148.721"
      r="1.33829"
      transform="rotate(142.441 310.302 148.721)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="274.05"
      cy="124.262"
      r="1.33829"
      transform="rotate(142.441 274.05 124.262)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="260.719"
      cy="143.517"
      r="1.33829"
      transform="rotate(142.441 260.719 143.517)"
      fill="#FF6300"
    />
    <circle
      cx="259.573"
      cy="159.59"
      r="1.33829"
      transform="rotate(142.441 259.573 159.59)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="253.047"
      cy="151.104"
      r="1.33829"
      transform="rotate(142.441 253.047 151.104)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="237.487"
      cy="163.068"
      r="1.33829"
      transform="rotate(142.441 237.487 163.068)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="232.211"
      cy="162.062"
      r="1.33829"
      transform="rotate(142.441 232.211 162.062)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="239.368"
      cy="141.363"
      r="1.33829"
      transform="rotate(142.441 239.368 141.363)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="242.685"
      cy="150.068"
      r="1.33829"
      transform="rotate(142.441 242.685 150.068)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="221.47"
      cy="144.434"
      r="1.33829"
      transform="rotate(142.441 221.47 144.434)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="223.24"
      cy="135.758"
      r="1.33829"
      transform="rotate(142.441 223.24 135.758)"
      fill="#FF6300"
    />
    <circle
      cx="212.741"
      cy="130.888"
      r="1.33829"
      transform="rotate(142.441 212.741 130.888)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="227.453"
      cy="152.214"
      r="1.33829"
      transform="rotate(142.441 227.453 152.214)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="245.32"
      cy="168.863"
      r="1.33829"
      transform="rotate(142.441 245.32 168.863)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="259.248"
      cy="154.776"
      r="1.33829"
      transform="rotate(142.441 259.248 154.776)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="261.454"
      cy="137.886"
      r="1.33829"
      transform="rotate(142.441 261.454 137.886)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="269.097"
      cy="135.385"
      r="1.33829"
      transform="rotate(142.441 269.097 135.385)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="260.94"
      cy="124.776"
      r="1.33829"
      transform="rotate(142.441 260.94 124.776)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
    <circle
      cx="249.053"
      cy="130.541"
      r="1.33829"
      transform="rotate(142.441 249.053 130.541)"
      fill="#FF6300"
    />
    <circle
      cx="247.011"
      cy="138.863"
      r="1.33829"
      transform="rotate(142.441 247.011 138.863)"
      fill="var(--color-background-black)"
      fill-opacity="0.59"
    />
  </svg>
</template>
